import React, { useState } from 'react';
import { PlusIcon, MapPinIcon, EditIcon, TrashIcon, CheckIcon } from 'lucide-react';
import { LocationModal } from '../modals/LocationModal';
export function AddressesSection() {
  const [addresses, setAddresses] = useState([{
    id: 1,
    label: 'Home',
    name: 'Ahmed Mohammed',
    phone: '+966 50 123 4567',
    city: 'Riyadh',
    district: 'Al Olaya',
    street: 'King Fahd Road, Building 123',
    additionalDetails: 'Apartment 4B',
    nationalAddressId: '1234-5678-9012',
    isDefault: true
  }, {
    id: 2,
    label: 'Work',
    name: 'Ahmed Mohammed',
    phone: '+966 50 123 4567',
    city: 'Riyadh',
    district: 'Al Malqa',
    street: 'Prince Turki Street, Tower 5',
    additionalDetails: 'Office 302',
    nationalAddressId: '',
    isDefault: false
  }]);
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const handleAddAddress = () => {
    setEditingAddress(null);
    setLocationModalOpen(true);
  };
  const handleEditAddress = address => {
    setEditingAddress(address);
    setLocationModalOpen(true);
  };
  const handleDeleteAddress = id => {
    if (window.confirm('Are you sure you want to delete this address?')) {
      setAddresses(addresses.filter(addr => addr.id !== id));
    }
  };
  const handleSetDefault = id => {
    setAddresses(addresses.map(addr => ({
      ...addr,
      isDefault: addr.id === id
    })));
  };
  const handleLocationSelect = location => {
    if (editingAddress) {
      // Update existing address
      setAddresses(addresses.map(addr => addr.id === editingAddress.id ? {
        ...addr,
        ...location
      } : addr));
    } else {
      // Add new address
      const newAddress = {
        id: addresses.length + 1,
        label: 'New Address',
        name: 'Ahmed Mohammed',
        phone: '+966 50 123 4567',
        ...location,
        isDefault: false
      };
      setAddresses([...addresses, newAddress]);
    }
    setLocationModalOpen(false);
    setEditingAddress(null);
  };
  return <div className="space-y-6" data-id="element-372" data-mp="1s1p8vz8ipzgc">
      <div className="flex items-center justify-between" data-id="element-373" data-mp="1x2mpi7dvqlfq">
        <h2 className="text-xl font-bold text-gray-900" data-id="element-374" data-mp="1x23hbie17bew">My Addresses</h2>
        <button onClick={handleAddAddress} className="flex items-center gap-2 px-4 py-2 bg-[#1E2B55] text-white text-sm font-medium rounded-lg hover:bg-[#162041] transition-colors" data-id="element-375" data-mp="10dx8eja2twut">
          <PlusIcon className="w-4 h-4" data-id="element-376" data-mp="19br3xs00omgx" />
          Add Address
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-377" data-mp="1e4sk03byms23">
        {addresses.map(address => <div key={address.id} className="bg-white rounded-xl border-2 border-gray-200 shadow-sm hover:shadow-md transition-all p-6" data-id="element-378" data-mp="gnv5ahqw0khi">
            <div className="flex items-start justify-between mb-4" data-id="element-379" data-mp="e4gqb21d7ti9">
              <div className="flex items-center gap-3" data-id="element-380" data-mp="9544mkm8csh9">
                <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0" data-id="element-381" data-mp="96f4488n7e2k">
                  <MapPinIcon className="w-6 h-6 text-[#1E2B55]" data-id="element-382" data-mp="447rdgfzntz6" />
                </div>
                <div data-id="element-383" data-mp="3w55z7z9lll">
                  <div className="flex items-center gap-2 mb-1" data-id="element-384" data-mp="6igm9xzol93">
                    <h3 className="font-bold text-gray-900 text-lg" data-id="element-385" data-mp="3rbifubt46oby">
                      {address.label}
                    </h3>
                    {address.isDefault && <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-green-100 text-green-700 text-xs font-medium rounded-full" data-id="element-386" data-mp="3hk5qbqusga93">
                        <CheckIcon className="w-3 h-3" data-id="element-387" data-mp="3cjrf5zxw4k6u" />
                        Default
                      </span>}
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-388" data-mp="33m7d4os7ejv6">{address.name}</p>
                </div>
              </div>
              <div className="flex items-center gap-2" data-id="element-389" data-mp="17jb23b0fdr13">
                <button onClick={() => handleEditAddress(address)} className="p-2 text-[#1E2B55] hover:bg-blue-50 rounded-lg transition-colors" title="Edit" data-id="element-390" data-mp="1bjd1temloadq">
                  <EditIcon className="w-5 h-5" data-id="element-391" data-mp="12q9iipp9x3b6" />
                </button>
                <button onClick={() => handleDeleteAddress(address.id)} className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors" title="Delete" data-id="element-392" data-mp="ntirp4to0zx6">
                  <TrashIcon className="w-5 h-5" data-id="element-393" data-mp="eunhzirex7p4" />
                </button>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-3 mb-4" data-id="element-394" data-mp="jsyr1r9vve6a">
              <div data-id="element-395" data-mp="296tt6hkb3ohf">
                <p className="text-xs text-gray-500 mb-1" data-id="element-396" data-mp="298oi06yp80qs">Phone</p>
                <p className="text-sm font-medium text-gray-900" data-id="element-397" data-mp="2e66l3gq1blqv">
                  {address.phone}
                </p>
              </div>
              <div data-id="element-398" data-mp="2ob6cn92kmv09">
                <p className="text-xs text-gray-500 mb-1" data-id="element-399" data-mp="2o8agnqaaageg">City</p>
                <p className="text-sm font-medium text-gray-900" data-id="element-400" data-mp="2jcd3fsubhq5w">
                  {address.city}
                </p>
              </div>
              <div data-id="element-401" data-mp="2x4t8ez6s3y9g">
                <p className="text-xs text-gray-500 mb-1" data-id="element-402" data-mp="2sc00k2g0k9t5">District</p>
                <p className="text-sm font-medium text-gray-900" data-id="element-403" data-mp="2s9vp8zfsc8iu">
                  {address.district}
                </p>
              </div>
              <div data-id="element-404" data-mp="322b6tvn66v37">
                <p className="text-xs text-gray-500 mb-1" data-id="element-405" data-mp="320qe8bkf1m7z">Street Address</p>
                <p className="text-sm font-medium text-gray-900" data-id="element-406" data-mp="3g22tekrr5jst">
                  {address.street}
                </p>
              </div>
              {address.additionalDetails && <div data-id="element-407" data-mp="1ln9yknyp0x1x">
                  <p className="text-xs text-gray-500 mb-1" data-id="element-408" data-mp="1lmrux69pbgjz">
                    Additional Details
                  </p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-409" data-mp="1hn9hswo4g9rp">
                    {address.additionalDetails}
                  </p>
                </div>}
              {address.nationalAddressId && <div data-id="element-410" data-mp="3lrvnsh004vu8">
                  <p className="text-xs text-gray-500 mb-1" data-id="element-411" data-mp="3qovwkzo8kcp1">
                    National Address ID
                  </p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-412" data-mp="3voialbbw1wyw">
                    {address.nationalAddressId}
                  </p>
                </div>}
            </div>
            {!address.isDefault && <button onClick={() => handleSetDefault(address.id)} className="text-sm font-medium text-[#1E2B55] hover:underline" data-id="element-413" data-mp="8hok2n15wjjl">
                Set as Default Address
              </button>}
          </div>)}
      </div>
      <LocationModal isOpen={locationModalOpen} onClose={() => {
      setLocationModalOpen(false);
      setEditingAddress(null);
    }} onSelectLocation={handleLocationSelect} initialAddress={editingAddress} data-id="element-414" data-mp="n9gnq1rlg95h" />
    </div>;
}